<script>
	// Stores
	import RuleStore from '@/Stores/RuleStore.js';
	// Components
	import Autocomplete from '@/Components/Autocomplete.svelte';

	export let newTag = '';
	export let selected = [];

	RuleStore.resetRules();
</script>

<div class="flex mt-1 space-x-2 mx-2">
	<Autocomplete
		bind:value={newTag}
		placeholder="Add a tag..."
		options={($RuleStore && $RuleStore.whereNotIn('tag', selected).pluck('tag').toArray()) ?? []}
		searchFunction={(key) => RuleStore.searchForTag(key)}
	/>
	<button on:click class="py-1 my-1 btn btn-black">Add</button>
</div>
